import React, {useMemo, useState, useEffect, forwardRef} from 'react';
import {connect} from 'react-redux';
import SelectOptionButton from 'app/Components/Shared/SelectOptionButton/SelectOptionButton';
import {styledNumber} from 'app/utilities/StringHelpers/TitleHelpers';
import {setSelectedNumber} from '../../changePhoneNumberSlice';
import {isMobile} from 'react-device-detect';

const NewNumbersData = forwardRef((props, ref) => {
  const [isVisible, setIsVisible] = useState(false);

  const numbersData = useMemo(() => {
    if (props.disabled) {
      return getFictitiousNumbersData();
    } else {
      return getNumbersData();
    }
  }, [props.changePhoneNumber.newNumbersData]);

  useEffect(() => {
    requestAnimationFrame(() => {
      setIsVisible(true);
    });
  }, []);

  function getFictitiousNumbersData() {
    const fictitiousData = [];
    for (let i = 0; i < 5; i++) {
      fictitiousData.push({
        id: i,
        label: props.marketCode === 'CLC' ? `052-3768941` : `058-3768941`,
        value: props.marketCode === 'CLC' ? `052-3768941` : `058-3768941`,
        showRadioButtons: true,
        disabled: true,
      });
    }
    return fictitiousData;
  }

  function getNumbersData() {
    const selectedType = props.changePhoneNumber.newNumbersData?.find((numberType) => numberType.selected);
    return (
      selectedType?.numbers?.map((numberItem, index) => ({
        id: index,
        label: `${styledNumber(numberItem)}`,
        value: numberItem,
        selected: props.changePhoneNumber.newSelectedNumber === numberItem,
        showRadioButtons: true,
      })) || []
    );
  }

  function handleNumberSelection(number) {
    props.setError(false);
    props.setSelectedNumber(number);
  }

  return (
    <div
      ref={ref}
      tabIndex={-1}
      className={`${props.disabled ? 'disabled' : ''} new-numbers-data-container smooth-fade-in ${isVisible ? 'visible' : ''}`}>
      <div className='border'></div>
      <div className={`l-title ${isMobile ? 'right' : ''}`}> לאיזה מספר להחליף? </div>
      <SelectOptionButton onClick={props.disabled ? null : handleNumberSelection} buttonsData={numbersData} />
    </div>
  );
});

NewNumbersData.displayName = 'NewNumbersData';

const mapStateToProps = (state) => ({
  changePhoneNumber: state.changePhoneNumber,
  marketCode: state.domain.MarketCode,
});
const mapDispatchToProps = {
  setSelectedNumber,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(NewNumbersData);
